<template>
  <div class="big">
    <div class="page_title">评价审核</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 20px;">
        <el-tabs v-model="activeName">
          <el-tab-pane label="待审核"
                       name="1"></el-tab-pane>
          <el-tab-pane label="已审核"
                       name="2"></el-tab-pane>
        </el-tabs>
        <component :is="currentComponent" />
      </div>
    </div>
  </div>
</template>
<script>
import EvaluationToBeReviewed from './EvaluationToBeReviewed.vue';
import EvaluationReviewed from './EvaluationReviewed.vue';
export default {
  data() {
    return {
      activeName: '1'
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    },
    currentComponent() {
      switch (this.activeName) {
        case '1':
          return EvaluationToBeReviewed;
        case '2':
          return EvaluationReviewed;
      }
    }
  },
  created() {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>
